<template>
  <v-tooltip bottom>
    <template v-slot:activator="data">
      <router-link
          :id="id"
          v-test="{ btn: id }"
          :to="to"
          custom
          class="route-link">
        <v-icon
            :color="iconColor"
            :x-large="xLarge"
            :small="small"
            :large="large"
            :medium="medium"
            :style="{ cursor: 'pointer' }"
            v-on="data.on">
          {{ icon }}
        </v-icon>
      </router-link>
    </template>
    <span>
      {{ tip }}
    </span>
  </v-tooltip>
</template>

<style scoped>
.route-link {
  text-decoration:none;
}
</style>

<script>
  export default {
    props: {
      tip: {
        type: String,
        default: ''
      },
      icon: {
        type: String,
        default: ''
      },
      iconColor: {
        type: String,
        default: 'primaryiconbtn'
      },
      id: {
        type: [String, Number],
        default: ''
      },
      to: {
        type: Object,
        default: () => {
          return {}
        }
      },
      xLarge: Boolean,
      large: Boolean,
      small: Boolean,
      medium: Boolean
    }
  }
</script>
